import { GridRow } from "Core/Controls/Grid/BaseGrid/GridRow/GridRow";

export class MenuItemModel {
	constructor(public row: GridRow,
		public DisplayValue: string, public Disabled: boolean) {
	}
}